"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = __importDefault(require("./urls"));
const mapEngagementByLocationResponse = (_a) => {
    var { location_id: locationId, location_name: locationName, pickup_to_screen_conversion: pickupToScreenConversion, total_interactions: totalInteractions } = _a, others = __rest(_a, ["location_id", "location_name", "pickup_to_screen_conversion", "total_interactions"]);
    return (Object.assign({ locationId,
        locationName,
        pickupToScreenConversion,
        totalInteractions }, others));
};
const mapEngagementByProductResponse = (_a) => {
    var { pickup_to_screen_conversion: pickupToScreenConversion, product_category_id: productCategoryId, product_category_name: productCategoryName, total_interactions: totalInteractions } = _a, others = __rest(_a, ["pickup_to_screen_conversion", "product_category_id", "product_category_name", "total_interactions"]);
    return (Object.assign({ pickupToScreenConversion,
        productCategoryId,
        productCategoryName,
        totalInteractions }, others));
};
const mapEngagementByClickResponse = (_a) => {
    var { page_title: pageTitle, page_type: pageType, percent_clicks_on_page: percentClicksOnPage, presentation_id: presentationId, presentation_name: presentationName, interaction_source: interactionSource } = _a, others = __rest(_a, ["page_title", "page_type", "percent_clicks_on_page", "presentation_id", "presentation_name", "interaction_source"]);
    return (Object.assign({ pageTitle,
        pageType,
        percentClicksOnPage,
        presentationId,
        presentationName,
        interactionSource }, others));
};
const mapGetAnalyticsResponse = ({ engagement_by_click, engagement_by_day: engagementByDay, engagement_by_day_previous_period: engagementByDayPreviousPeriod, engagement_by_location, engagement_by_product, }) => ({
    engagementByClick: engagement_by_click === null || engagement_by_click === void 0 ? void 0 : engagement_by_click.map(mapEngagementByClickResponse),
    engagementByDay,
    engagementByDayPreviousPeriod,
    engagementByLocation: engagement_by_location === null || engagement_by_location === void 0 ? void 0 : engagement_by_location.map(mapEngagementByLocationResponse),
    engagementByProduct: engagement_by_product === null || engagement_by_product === void 0 ? void 0 : engagement_by_product.map(mapEngagementByProductResponse),
});
const mapContentEngagementSummaryResponse = (_a) => {
    var { dwell_duration: dwellDuration, avg_dwell_duration: avgDwellDuration, ots_face: otsFace, dwell_face_duration: dwellFaceDuration, avg_dwell_face_duration: avgDwellFaceDuration, verified_views: verifiedViews, avg_verified_views_per_day: avgVerifiedViewsPerDay, avg_verified_views_per_week: avgVerifiedViewsPerWeek, view_duration: viewDuration, avg_view_duration: avgViewDuration, avg_impressions_per_day: avgImpressionsPerDay, avg_impressions_per_week: avgImpressionsPerWeek, engaged_views: engagedViews, avg_engaged_views_per_day: avgEngagedViewsPerDay, avg_engaged_views_per_week: avgEngagedViewsPerWeek, verified_views_rate: verifiedViewsRate, engaged_views_rate: engagedViewsRate } = _a, others = __rest(_a, ["dwell_duration", "avg_dwell_duration", "ots_face", "dwell_face_duration", "avg_dwell_face_duration", "verified_views", "avg_verified_views_per_day", "avg_verified_views_per_week", "view_duration", "avg_view_duration", "avg_impressions_per_day", "avg_impressions_per_week", "engaged_views", "avg_engaged_views_per_day", "avg_engaged_views_per_week", "verified_views_rate", "engaged_views_rate"]);
    return (Object.assign({ dwellDuration,
        avgDwellDuration,
        otsFace,
        dwellFaceDuration,
        avgDwellFaceDuration,
        verifiedViews,
        avgVerifiedViewsPerDay,
        avgVerifiedViewsPerWeek,
        viewDuration,
        avgViewDuration,
        avgImpressionsPerDay,
        avgImpressionsPerWeek,
        engagedViews,
        avgEngagedViewsPerDay,
        avgEngagedViewsPerWeek,
        verifiedViewsRate,
        engagedViewsRate }, others));
};
const mapContentEngagementByPresentationResponse = (_a) => {
    var { presentation_id: presentationId, presentation_name: presentationName, n_of_plays: nOfPlays, avg_duration: avgDuration, playback_duration: playbackDuration, n_of_locations: nOfLocations, last_played_time: lastPlayedTime, playback_distribution: playbackDistribution, dwell_duration: dwellDuration, avg_dwell_duration: avgDwellDuration, ots_face: otsFace, dwell_face_duration: dwellFaceDuration, avg_dwell_face_duration: avgDwellFaceDuration, verified_views: verifiedViews, view_duration: viewDuration, avg_view_duration: avgViewDuration, verified_views_rate: verifiedViewsRate, engaged_views: engagedViews, engaged_views_rate: engagedViewsRate } = _a, others = __rest(_a, ["presentation_id", "presentation_name", "n_of_plays", "avg_duration", "playback_duration", "n_of_locations", "last_played_time", "playback_distribution", "dwell_duration", "avg_dwell_duration", "ots_face", "dwell_face_duration", "avg_dwell_face_duration", "verified_views", "view_duration", "avg_view_duration", "verified_views_rate", "engaged_views", "engaged_views_rate"]);
    return (Object.assign({ presentationId,
        presentationName,
        nOfPlays,
        avgDuration,
        playbackDuration,
        nOfLocations,
        lastPlayedTime,
        playbackDistribution,
        dwellDuration,
        avgDwellDuration,
        otsFace,
        dwellFaceDuration,
        avgDwellFaceDuration,
        verifiedViews,
        viewDuration,
        avgViewDuration,
        verifiedViewsRate,
        engagedViews,
        engagedViewsRate }, others));
};
const mapContentEngagementByClickResponse = (_a) => {
    var { presentation_id: presentationId, presentation_name: presentationName, interaction_source: interactionSource, page_type: pageType, page_title: pageTitle, percent_clicks_on_page: percentClicksOnPage } = _a, others = __rest(_a, ["presentation_id", "presentation_name", "interaction_source", "page_type", "page_title", "percent_clicks_on_page"]);
    return (Object.assign({ presentationId,
        presentationName,
        interactionSource,
        pageType,
        pageTitle,
        percentClicksOnPage }, others));
};
const mapGetContentEngagementesponse = ({ content_engagement_summary, content_engagement_summary_previous_period, content_engagement_by_presentation, content_engagement_by_click, }) => ({
    contentEngagementSummary: content_engagement_summary === null || content_engagement_summary === void 0 ? void 0 : content_engagement_summary.map(mapContentEngagementSummaryResponse),
    contentEngagementSummaryPreviousPeriod: content_engagement_summary_previous_period === null || content_engagement_summary_previous_period === void 0 ? void 0 : content_engagement_summary_previous_period.map(mapContentEngagementSummaryResponse),
    contentEngagementByPresentation: content_engagement_by_presentation === null || content_engagement_by_presentation === void 0 ? void 0 : content_engagement_by_presentation.map(mapContentEngagementByPresentationResponse),
    contentEngagementByClick: content_engagement_by_click === null || content_engagement_by_click === void 0 ? void 0 : content_engagement_by_click.map(mapContentEngagementByClickResponse),
});
const mapTrafficSummaryResponse = (_a) => {
    var { ots: ots, avg_ots_per_day: avgOtsPerDay, avg_ots_per_week: avgOtsPerWeek, dwell_time: dwellTime, avg_dwell_time: avgDwellTime, ots_face: otsFace, avg_ots_face_per_day: avgOtsFacePerDay, avg_ots_face_per_week: avgOtsFacePerWeek, dwell_time_face: dwellTimeFace, avg_dwell_time_face: avgDwellTimeFace, screen_placement_quality: screenPlacementQuality, impressions: impressions, avg_impressions_per_day: avgImpressionsPerDay, avg_impressions_per_week: avgImpressionsPerWeek, verified_views: verifiedViews, avg_verified_views_per_day: avgVerifiedViewsPerDay, avg_verified_views_per_week: avgVerifiedViewsPerWeek, verified_views_rate: verifiedViewsRate, engaged_views: engagedViews, avg_engaged_views_per_day: avgEngagedViewsPerDay, avg_engaged_views_per_week: avgEngagedViewsPerWeek, engaged_views_rate: engagedViewsRate } = _a, others = __rest(_a, ["ots", "avg_ots_per_day", "avg_ots_per_week", "dwell_time", "avg_dwell_time", "ots_face", "avg_ots_face_per_day", "avg_ots_face_per_week", "dwell_time_face", "avg_dwell_time_face", "screen_placement_quality", "impressions", "avg_impressions_per_day", "avg_impressions_per_week", "verified_views", "avg_verified_views_per_day", "avg_verified_views_per_week", "verified_views_rate", "engaged_views", "avg_engaged_views_per_day", "avg_engaged_views_per_week", "engaged_views_rate"]);
    return (Object.assign({ ots,
        avgOtsPerDay,
        avgOtsPerWeek,
        dwellTime,
        avgDwellTime,
        otsFace,
        avgOtsFacePerDay,
        avgOtsFacePerWeek,
        dwellTimeFace,
        avgDwellTimeFace,
        screenPlacementQuality,
        impressions,
        avgImpressionsPerDay,
        avgImpressionsPerWeek,
        verifiedViews,
        avgVerifiedViewsPerDay,
        avgVerifiedViewsPerWeek,
        verifiedViewsRate,
        engagedViews,
        avgEngagedViewsPerDay,
        avgEngagedViewsPerWeek,
        engagedViewsRate }, others));
};
const mapTrafficByDayResponse = (_a) => {
    var { dwell_time: dwellTime, avg_dwell_time: avgDwellTime, ots_face: otsFace, dwell_time_face: dwellTimeFace, avg_dwell_time_face: avgDwellTimeFace, verified_views: verifiedViews, engaged_views: engagedViews } = _a, others = __rest(_a, ["dwell_time", "avg_dwell_time", "ots_face", "dwell_time_face", "avg_dwell_time_face", "verified_views", "engaged_views"]);
    return (Object.assign({ dwellTime,
        avgDwellTime,
        otsFace,
        dwellTimeFace,
        avgDwellTimeFace,
        verifiedViews,
        engagedViews }, others));
};
const mapTrafficByLocationResponse = (_a) => {
    var { location_id: locationId, location_name: locationName, dwell_time: dwellTime, avg_dwell_time: avgDwellTime, ots_face: otsFace, dwell_time_face: dwellTimeFace, avg_dwell_time_face: avgDwellTimeFace, verified_views: verifiedViews, engaged_views: engagedViews, screen_placement_quality: screenPlacementQuality, verified_views_rate: verifiedViewsRate, avg_viewing_time: avgViewingTime } = _a, others = __rest(_a, ["location_id", "location_name", "dwell_time", "avg_dwell_time", "ots_face", "dwell_time_face", "avg_dwell_time_face", "verified_views", "engaged_views", "screen_placement_quality", "verified_views_rate", "avg_viewing_time"]);
    return (Object.assign({ locationId,
        locationName,
        dwellTime,
        avgDwellTime,
        otsFace,
        dwellTimeFace,
        avgDwellTimeFace,
        verifiedViews,
        engagedViews,
        screenPlacementQuality,
        verifiedViewsRate,
        avgViewingTime }, others));
};
const mapTrafficByWeekdayHourResponse = (_a) => {
    var { dwell_time: dwellTime, avg_dwell_time: avgDwellTime, ots_face: otsFace, dwell_time_face: dwellTimeFace, avg_dwell_time_face: avgDwellTimeFace, verified_views: verifiedViews, engaged_views: engagedViews } = _a, others = __rest(_a, ["dwell_time", "avg_dwell_time", "ots_face", "dwell_time_face", "avg_dwell_time_face", "verified_views", "engaged_views"]);
    return (Object.assign({ dwellTime,
        avgDwellTime,
        otsFace,
        dwellTimeFace,
        avgDwellTimeFace,
        verifiedViews,
        engagedViews }, others));
};
const mapInteractionsResponse = (_a) => {
    var { total_interactions: totalInteractions } = _a, others = __rest(_a, ["total_interactions"]);
    return (Object.assign({ totalInteractions }, others));
};
const mapGetTrafficAwarenessResponse = ({ traffic_summary, traffic_summary_previous_period, traffic_by_day, traffic_by_location, traffic_by_weekday_hour, interactions, }) => ({
    trafficSummary: traffic_summary === null || traffic_summary === void 0 ? void 0 : traffic_summary.map(mapTrafficSummaryResponse),
    trafficSummaryPreviousPeriod: traffic_summary_previous_period === null || traffic_summary_previous_period === void 0 ? void 0 : traffic_summary_previous_period.map(mapTrafficSummaryResponse),
    trafficByDay: traffic_by_day === null || traffic_by_day === void 0 ? void 0 : traffic_by_day.map(mapTrafficByDayResponse),
    trafficByLocation: traffic_by_location === null || traffic_by_location === void 0 ? void 0 : traffic_by_location.map(mapTrafficByLocationResponse),
    trafficByWeekdayHour: traffic_by_weekday_hour === null || traffic_by_weekday_hour === void 0 ? void 0 : traffic_by_weekday_hour.map(mapTrafficByWeekdayHourResponse),
    interactions: interactions === null || interactions === void 0 ? void 0 : interactions.map(mapInteractionsResponse),
});
const mapContentDetailSummaryResponse = (_a) => {
    var { presentation_id: presentationId, presentation_name: presentationName, n_of_plays: nOfPlays, playback_duration: playbackDuration, n_of_locations: nOfLocations, n_of_playlists: nOfPlaylists, n_of_screens: nOfScreens, n_of_days: nOfDays, first_time_played: firstTimePlayed, last_time_played: lastTimePlayed, dwell_duration: dwellDuration, avg_dwell_duration: avgDwellDuration, all_avg_dwell_duration: allAvgDwellDuration, verified_views: verifiedViews, all_avg_verified_views: allAvgVerifiedViews, view_duration: viewDuration, avg_view_duration: avgViewDuration, all_avg_view_duration: allAvgViewDuration, all_avg_impressions: allAvgImpressions, screen_placement_quality: screenPlacementQuality, all_screen_placement_quality: allScreenPlacementQuality, engaged_views: engagedViews, all_avg_engaged_views: allAvgEngagedViews, verified_views_rate: verifiedViewsRate, all_avg_verified_views_rate: allAvgVerifiedViewsRate, engaged_views_rate: engagedViewsRate, all_avg_engaged_views_rate: allAvgEngagedViewsRate, verified_views_female: verifiedViewsFemale, verified_views_female_percentage: verifiedViewsFemalePercentage, avg_viewing_duration_female: avgViewingDurationFemale, verified_view_rate_female: verifiedViewRateFemale, verified_views_male: verifiedViewsMale, verified_views_male_percentage: verifiedViewsMalePercentage, avg_viewing_duration_male: avgViewingDurationMale, verified_view_rate_male: verifiedViewRateMale } = _a, others = __rest(_a, ["presentation_id", "presentation_name", "n_of_plays", "playback_duration", "n_of_locations", "n_of_playlists", "n_of_screens", "n_of_days", "first_time_played", "last_time_played", "dwell_duration", "avg_dwell_duration", "all_avg_dwell_duration", "verified_views", "all_avg_verified_views", "view_duration", "avg_view_duration", "all_avg_view_duration", "all_avg_impressions", "screen_placement_quality", "all_screen_placement_quality", "engaged_views", "all_avg_engaged_views", "verified_views_rate", "all_avg_verified_views_rate", "engaged_views_rate", "all_avg_engaged_views_rate", "verified_views_female", "verified_views_female_percentage", "avg_viewing_duration_female", "verified_view_rate_female", "verified_views_male", "verified_views_male_percentage", "avg_viewing_duration_male", "verified_view_rate_male"]);
    return (Object.assign({ presentationId,
        presentationName,
        nOfPlays,
        playbackDuration,
        nOfLocations,
        nOfPlaylists,
        nOfScreens,
        nOfDays,
        firstTimePlayed,
        lastTimePlayed,
        dwellDuration,
        avgDwellDuration,
        allAvgDwellDuration,
        verifiedViews,
        allAvgVerifiedViews,
        viewDuration,
        avgViewDuration,
        allAvgViewDuration,
        allAvgImpressions,
        screenPlacementQuality,
        allScreenPlacementQuality,
        engagedViews,
        allAvgEngagedViews,
        verifiedViewsRate,
        allAvgVerifiedViewsRate,
        engagedViewsRate,
        allAvgEngagedViewsRate,
        verifiedViewsFemale,
        verifiedViewsFemalePercentage,
        avgViewingDurationFemale,
        verifiedViewRateFemale,
        verifiedViewsMale,
        verifiedViewsMalePercentage,
        avgViewingDurationMale,
        verifiedViewRateMale }, others));
};
const mapContentDetailByPlaylistResponse = (_a) => {
    var { playlist_id: playlistId, playlist_name: playlistName, n_of_plays: nOfPlays, playback_duration: playbackDuration, n_of_locations: nOfLocations, first_time_played: firstTimePlayed, last_time_played: lastTimePlayed, dwell_duration: dwellDuration, avg_dwell_duration: avgDwellDuration, verified_views: verifiedViews, view_duration: viewDuration, avg_view_duration: avgViewDuration, engaged_views: engagedViews, verified_views_rate: verifiedViewsRate, engaged_views_rate: engagedViewsRate } = _a, others = __rest(_a, ["playlist_id", "playlist_name", "n_of_plays", "playback_duration", "n_of_locations", "first_time_played", "last_time_played", "dwell_duration", "avg_dwell_duration", "verified_views", "view_duration", "avg_view_duration", "engaged_views", "verified_views_rate", "engaged_views_rate"]);
    return (Object.assign({ playlistId,
        playlistName,
        nOfPlays,
        playbackDuration,
        nOfLocations,
        firstTimePlayed,
        lastTimePlayed,
        dwellDuration,
        avgDwellDuration,
        verifiedViews,
        viewDuration,
        avgViewDuration,
        engagedViews,
        verifiedViewsRate,
        engagedViewsRate }, others));
};
const mapContentDetailByLocationResponse = (_a) => {
    var { location_id: locationId, location_name: locationName, n_of_plays: nOfPlays, playback_duration: playbackDuration, first_played_time: firstPlayedTime, last_played_time: lastPlayedTime, dwell_duration: dwellDuration, avg_dwell_duration: avgDwellDuration, verified_views: verifiedViews, view_duration: viewDuration, avg_view_duration: avgViewDuration, engaged_views: engagedViews, verified_views_rate: verifiedViewsRate, engaged_views_rate: engagedViewsRate } = _a, others = __rest(_a, ["location_id", "location_name", "n_of_plays", "playback_duration", "first_played_time", "last_played_time", "dwell_duration", "avg_dwell_duration", "verified_views", "view_duration", "avg_view_duration", "engaged_views", "verified_views_rate", "engaged_views_rate"]);
    return (Object.assign({ locationId,
        locationName,
        nOfPlays,
        playbackDuration,
        firstPlayedTime,
        lastPlayedTime,
        dwellDuration,
        avgDwellDuration,
        verifiedViews,
        viewDuration,
        avgViewDuration,
        engagedViews,
        verifiedViewsRate,
        engagedViewsRate }, others));
};
const mapContentDetailByDayResponse = (_a) => {
    var { timestamp: timestamp, n_of_plays: nOfPlays, playback_duration: playbackDuration, dwell_duration: dwellDuration, avg_dwell_duration: avgDwellDuration, verified_views: verifiedViews, view_duration: viewDuration, avg_view_duration: avgViewDuration, engaged_views: engagedViews, verified_views_rate: verifiedViewsRate, engaged_views_rate: engagedViewsRate } = _a, others = __rest(_a, ["timestamp", "n_of_plays", "playback_duration", "dwell_duration", "avg_dwell_duration", "verified_views", "view_duration", "avg_view_duration", "engaged_views", "verified_views_rate", "engaged_views_rate"]);
    return (Object.assign({ timestamp,
        nOfPlays,
        playbackDuration,
        dwellDuration,
        avgDwellDuration,
        verifiedViews,
        viewDuration,
        avgViewDuration,
        engagedViews,
        verifiedViewsRate,
        engagedViewsRate }, others));
};
const mapGetContentDetailResponse = ({ content_engagement_detail_summary, content_engagement_detail_by_playlist, content_engagement_detail_by_location, content_engagement_detail_by_day, }) => ({
    contentDetailSummary: content_engagement_detail_summary === null || content_engagement_detail_summary === void 0 ? void 0 : content_engagement_detail_summary.map(mapContentDetailSummaryResponse),
    contentDetailByPlaylist: content_engagement_detail_by_playlist === null || content_engagement_detail_by_playlist === void 0 ? void 0 : content_engagement_detail_by_playlist.map(mapContentDetailByPlaylistResponse),
    contentDetailByLocation: content_engagement_detail_by_location === null || content_engagement_detail_by_location === void 0 ? void 0 : content_engagement_detail_by_location.map(mapContentDetailByLocationResponse),
    contentDetailByDay: content_engagement_detail_by_day === null || content_engagement_detail_by_day === void 0 ? void 0 : content_engagement_detail_by_day.map(mapContentDetailByDayResponse),
});
class AnalyticsClient {
    getAnalytics(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getAnalytics(query),
            });
            return mapGetAnalyticsResponse(data);
        });
    }
    getLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.requestProtected({
                method: 'GET',
                url: urls_1.default.getLocations(),
            });
        });
    }
    getContentEngagement(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getContentEngagement(query),
            });
            return mapGetContentEngagementesponse(data);
        });
    }
    getTrafficAwareness(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const trafficAwarenessQuery = Object.assign(Object.assign({}, query), { location_id: [query.location_id] });
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getTrafficAwareness(trafficAwarenessQuery),
            });
            return mapGetTrafficAwarenessResponse(data);
        });
    }
    getTrafficAwarenessExport(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const trafficAwarenessQuery = Object.assign(Object.assign({}, query), { location_id: [query.location_id] });
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getTrafficAwarenessExport(trafficAwarenessQuery),
            });
            return data;
        });
    }
    getContentEngagementExport(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getContentEngagementExport(query),
                responseType: 'blob',
            });
            return data;
        });
    }
    getContentEngagementClickExport(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getContentEngagementClickExport(query),
            });
            return data;
        });
    }
    getProductEngagementExport(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getProductEngagementExport(query),
            });
            return data;
        });
    }
    getContentDetail(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getContentDetail(query),
            });
            return mapGetContentDetailResponse(data);
        });
    }
}
exports.default = AnalyticsClient;
